module.exports = __webpack_public_path__ + "static/media/bindingAddress.ea46f825.svg";